import { Text } from '@auspost/postmaster-react';

import { extLnkPostOfficeLocatorWithShowpop } from '../../../../config/track-config';
import { Milestone } from '../../../../models/shipments';
import { ArrowLink } from '../../DialogueCardPanel/cards/Arrows';
import { useCurrentArticle } from '../../hooks/shipment.hooks';

import styles from './MapAndHoursLink.module.scss';

const MapAndHoursLink: React.FC = () => {
  const currentArticle = useCurrentArticle();

  const wcid = currentArticle?.collectionInstruction?.facility?.workCentreId;
  const isAwaitingCollection = currentArticle?.events[0]?.milestone === Milestone.AWAITING_COLLECTION;
  const isParcelLocker = currentArticle?.collectionInstruction?.facility?.type === 'PARCEL_LOCKER';
  const hasAccessCode = currentArticle?.accessCode;

  const shouldShowMapAndHoursLink = !hasAccessCode && isParcelLocker && wcid && isAwaitingCollection;

  if (!shouldShowMapAndHoursLink) {
    return null;
  }

  const url = `${extLnkPostOfficeLocatorWithShowpop}${wcid}`;

  return (
    <ArrowLink
      href={url}
      target='_blank'
      rel='noopener noreferrer'
      className={styles.container}
      data-testid='mapAndHoursLink'
    >
      <Text variant='body-small' weight='medium'>
        Collection location and hours
      </Text>
    </ArrowLink>
  );
};

export default MapAndHoursLink;
